var _a;
import React from 'react';
// @ts-ignore:next-line
import { Loading, TextLink } from '@folio/stripes/components';
import { t, formatNumber, formatTime, formatDate } from '../../../services/translation';
import { HOME_PAGE_URL, COLUMNS_NAME } from '../../../constants';
export var listTableResultFormatter = (_a = {},
    _a[COLUMNS_NAME.LIST_NAME] = function (item) { return (React.createElement(TextLink, { to: "".concat(HOME_PAGE_URL, "/list/").concat(item.id) }, item.name)); },
    _a[COLUMNS_NAME.STATUS] = function (item) { return (t(item.isActive
        ? 'lists.item.active'
        : 'lists.item.inactive')); },
    _a[COLUMNS_NAME.VISIBILITY] = function (item) { return (t(item.isPrivate
        ? 'lists.item.private'
        : 'lists.item.shared')); },
    _a[COLUMNS_NAME.SOURCE] = function (item) { return (item.isCanned ? (t('list.info.source.system')) : (React.createElement(React.Fragment, null, item.createdByUsername))); },
    _a[COLUMNS_NAME.RECORDS] = function (item) { return (item.isRefreshing
        ? React.createElement(React.Fragment, null,
            React.createElement("span", { style: { whiteSpace: 'nowrap' } }, t('lists.item.compiling')),
            React.createElement(Loading, null))
        : React.createElement(React.Fragment, null, formatNumber(item.recordsCount))); },
    _a[COLUMNS_NAME.LAST_UPDATED] = function (item) { return (item.refreshedDate ?
        React.createElement(React.Fragment, null,
            formatDate(item.refreshedDate),
            " ",
            formatTime(item.refreshedDate))
        :
            React.createElement(React.Fragment, null)); },
    _a);
